module.exports = __webpack_public_path__ + "img/item5.ea9557b9.png";